export default {
  'claimant.firstName': 'Claimant First Name',
  'claimant.lastName': 'Claimant Last Name',
  'claimNumber': 'Claim Number',
  'roadHazardId': 'Road Hazard Id',
  'invoiceNumber': 'Invoice #',
  'dealerId': 'Dealer',
};